import React, { useState } from "react";
import { Row, Col, Card, Menu, Dropdown, Button } from "antd";
import { IoIosAddCircleOutline } from "react-icons/io";
import { BsThreeDotsVertical, BiCheckDouble } from "react-icons/all";
import Chip from "../../assets/images/chip.png";
import straightVisaCard from "../../assets/images/straight_cards_32.png";
import "./index.css";
import info from "../../components/info";
import { useDispatch } from "react-redux";
import { UserAction } from "../../store/actions";
import CustomModal from "../modals/customModal";
import Delete_order from "../../assets/images/delete_order.png";

export default function CreditPurchase({
  inputText,
  cardIcon,
  cardText,
  cardStyle,
  data,
  fromOrder,
  tickIcon,
  dotsIcon,
  paidText,
  shipVisaStyling,
}) {
  const [isOpenModal, setOpenModal] = useState(false);
  const dispatch = useDispatch();
  console.log("DATA==>", data);
  const menu = (
    <Menu style={{ width: 0, padding: 0 }} className="menu-fit">
      {!data?.default_source && (
        <Menu.Item
          key="0"
          onClick={() => dispatch(UserAction.setCardDefaultReq(data.id))}
          style={{ marginLeft: "-5px" }}
        >
          <span className="st-primary">Set as default</span>
        </Menu.Item>
      )}

      <Menu.Item
        key="0"
        onClick={
          data?.default_source
            ? () => {
                info(
                  "error",
                  "Cannot delete default card! Make any other card your default and then delete this card"
                );
              }
            : () => setOpenModal(true)
        }
        style={{ marginLeft: "-5px" }}
      >
        <span className="st-primary">Delete</span>
      </Menu.Item>
    </Menu>
  );
  return (
    <Row justify={fromOrder ? "space-between" : "center"}>
      <Col xs={24} sm={24} md={24} lg={22} xl={22} className="custom">
        <Card className="ant-card-body" style={cardStyle}>
          <Row>
            <Col
              xs={24}
              sm={8}
              md={18}
              lg={22}
              xl={24}
              className="text-left"
              style={{
                paddingLeft: "10px",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              <span>{inputText}</span>
            </Col>
            <Col
              xs={24}
              sm={8}
              md={18}
              lg={22}
              xl={24}
              className="text-left"
              style={{
                paddingLeft: "10px",
                marginTop: "10px",
                marginBottom: "24px",
              }}
            >
              <span className="c-purchase">CREDIT PURCHASE</span>
            </Col>
          </Row>
        </Card>
      </Col>
      <CustomModal
        visible={isOpenModal}
        onCancelModal={() => setOpenModal(false)}
        footer={[
          <Row justify="center" style={{ margin: "20px" }}>
            <Col
              className="d-flex justify-content-center"
              style={{ width: "100%" }}
            >
              <Button
                style={{
                  backgroundColor: "#ff9800",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() =>
                  dispatch(
                    UserAction.deleteCardReq(data.id, () => setOpenModal(false))
                  )
                }
              >
                YES
              </Button>
              <Button
                style={{
                  backgroundColor: "#26a69a ",
                  color: "#fff",
                  width: "30%",
                  border: "none",
                }}
                onClick={() => setOpenModal(false)}
              >
                NO
              </Button>
            </Col>
          </Row>,
        ]}
      >
        <Row justify="center">
          <Col className="d-flex justify-content-center" span={24}>
            <img src={Delete_order} />
          </Col>
          <Col span={24} style={{ textAlign: "center" }}>
            <span>{"Are you sure you want to delete this card?"}</span>
          </Col>
        </Row>
      </CustomModal>
    </Row>
  );
}
